import router from 'next/router';
import { connect } from 'react-redux';
import urlsService from '@/services/urls-service';
import { ApiPagination } from '@/components/Pagination/ApiPagination';
import { selectPaginationItems, selectPaginationRelative } from '../stores/selectors';
import { getProducts } from '../stores/productSearchSlice';
import type { ApiPaginationItem } from '@/components/Pagination/types';

export const mapStateToProps = (state: any, ownProps: any) => {
  const items = selectPaginationItems(state);
  const { prev = undefined, next = undefined } = selectPaginationRelative(state);

  const nextProps = {
    ...(items && { items }),
    relative: {
      ...(prev && { prev }),
      ...(next && { next })
    }
  };

  return {
    ...ownProps,
    ...nextProps
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onPaginationChange: (paginationItem: ApiPaginationItem) => {
      const apiUrl = urlsService.getUrl(paginationItem.urlSet.api);
      getProducts(dispatch)({ apiUrl });
      const nextUrl = `${document.location.origin}${paginationItem.urlSet.web}`;
      router.push(nextUrl);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApiPagination);
